<template>
  <div class="contents">
    <top></top>
    <div class="topUp-list">
      <div class="search">
        <div class="search_l">
          <el-input
            @change="getTopUpList(1)"
            placeholder="请输入租户名称"
            prefix-icon="el-icon-search"
            size="small"
            clearable
            style="width: 188px; margin-right: 10px"
            v-model="queryParams.companyName"
          >
          </el-input>
          <el-date-picker
            @change="handleDate"
            v-model="date"
            type="datetimerange"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="small"
          >
          </el-date-picker>
        </div>
        <div class="search_r">
          <el-input
            @change="getTopUpList(1)"
            placeholder="请输入系统流水号"
            prefix-icon="el-icon-search"
            size="small"
            clearable
            v-model="queryParams.cid"
            @input="inputTopUp"
          >
          </el-input>
        </div>
      </div>
      <div class="table_box">
        <el-table :data="topUpList" v-loading="loading" height="100%">
          <el-table-column label="系统流水号" prop="cid" width="150"></el-table-column>
          <el-table-column label="租户编号" prop="tenantId"></el-table-column>
          <el-table-column label="租户名称" prop="companyName" width="150" show-overflow-tooltip></el-table-column>
          <el-table-column label="币种" prop="currency"></el-table-column>
          <el-table-column label="金额" prop="amount"></el-table-column>
          <el-table-column label="地址" prop="address" width="200" show-overflow-tooltip></el-table-column>
          <el-table-column label="交易hash" prop="txid" width="100" show-overflow-tooltip></el-table-column>
          <el-table-column label="创建时间" prop="createTime" width="160"></el-table-column>
        </el-table>
      </div>
      <div class="table-pagination">
        <el-pagination
          background
          class="penye"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          layout="total, prev, pager, next"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import top from "./components/top.vue";
export default {
  data() {
    return {
      loading: false,
      topUpList: [],
      date: [],
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        startTime: null,
        endTime: null,
        companyName: null,
        tenantId: null,
        cid: null,
      },
      total: 0,
    };
  },
  mounted() {
    this.getTopUpList();
  },
  computed: {
    roles() {
      return this.$store.state.userStore.roles;
    },
  },
  components: {
    top,
  },
  methods: {
    inputTopUp(val) {
      const onlyNum = val.replace(/\D/g, "");
      this.queryParams.cid = onlyNum;
    },
    handleDate(e) {
      if (e) {
        this.queryParams.startTime = e[0];
        this.queryParams.endTime = e[1];
        this.getTopUpList(1);
      } else {
        this.queryParams.startTime = null;
        this.queryParams.endTime = null;
        this.getTopUpList(1);
      }
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.getTopUpList();
    },
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getTopUpList();
    },
    getTopUpList(val) {
      this.loading = true;
      if (val == 1) {
        this.queryParams.pageNum = 1;
      }
      this.$http({
        url: "/customer/transactionList",
        method: "POST",
        data: this.queryParams,
      })
        .then((res) => {
          this.topUpList = res.rows;
          this.total = res.total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.contents {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.topUp-list {
  flex: 1;
  padding: 20px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.search {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  flex-shrink: 0;
}

.search_l {
  display: flex;
  justify-content: flex-start;
  width: 60%;
}

.search_r {
  width: 30%;
}

.table_box {
  width: 99%;
  height: 100%;
}

.table-button {
  margin-right: 10px;
  font-size: 20px;
}

.table-pagination {
  flex-shrink: 0;
  text-align: right;
  padding-top: 20px;
}

.topTopUp {
  text-align: right;
  cursor: pointer;
}
</style>
